import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
const app = createApp(App)
app.config.errorHandler = (err, vm, info) => {
  // err是错误对象
  // vm是发生错误的Vue实例
  // info是一个包含错误来源信息的字符串
  console.log('捕获到错误：', err)
  // 这里可以添加自定义的错误处理逻辑，比如上报错误到服务器
  // 如果你不想在控制台显示错误，可以不进行console.log操作
}
app.use(store).use(router).use(Antd).mount('#app')
